import React from 'react';
import { Home } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white pt-16 pb-8 border-t border-white/10" data-id="element-94">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-95">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-96">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-97">
            <div className="flex items-center space-x-2 mb-4" data-id="element-98">
              <Home className="w-6 h-6 text-brand-gold" data-id="element-99" />
              <span className="font-heading font-bold text-xl tracking-widest uppercase" data-id="element-100">
                Donavan Smith
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-sm" data-id="element-101">
              Helping you navigate the Arizona real estate market with
              confidence, expertise, and a commitment to your goals.
            </p>
            <div className="flex items-center space-x-4" data-id="element-102">
              <span className="text-sm font-bold text-white" data-id="element-103">
                Realty One Group
              </span>
              <span className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-104"></span>
              <span className="text-sm text-gray-400" data-id="element-105">Team Lehman AZ</span>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-106">
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6" data-id="element-107">
              Navigation
            </h4>
            <ul className="space-y-3" data-id="element-108">
              {['Home', 'About', 'Services', 'Communities', 'Contact'].map(item => <li key={item} data-id="element-109">
                    <a href={`#${item.toLowerCase()}`} className="text-gray-400 hover:text-brand-gold transition-colors text-sm" data-id="element-110">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-111">
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-6" data-id="element-112">
              Legal
            </h4>
            <ul className="space-y-3" data-id="element-113">
              <li data-id="element-114">
                <a href="#" className="text-gray-400 hover:text-brand-gold transition-colors text-sm" data-id="element-115">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-116">
                <a href="#" className="text-gray-400 hover:text-brand-gold transition-colors text-sm" data-id="element-117">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-118">
                <a href="#" className="text-gray-400 hover:text-brand-gold transition-colors text-sm" data-id="element-119">
                  Fair Housing Notice
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-120">
          <p data-id="element-121">
            &copy; {new Date().getFullYear()} Donavan Smith Real Estate. All
            rights reserved.
          </p>
          <div className="flex items-center space-x-4 mt-4 md:mt-0" data-id="element-122">
            <span data-id="element-123">Equal Housing Opportunity</span>
            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/EHO_logo.svg/1200px-EHO_logo.svg.png" alt="Equal Housing Opportunity" className="h-6 opacity-50 grayscale" data-id="element-124" />
          </div>
        </div>
      </div>
    </footer>;
}